// extracted by mini-css-extract-plugin
module.exports = {"loadingOverlay":"_2YOHd","cell":"kAs-b","bottomText":"_3T8LQ"};